var e4 = e4 || {},
    unique = unique || {};